import { useEffect, useRef, useState } from "react";

import { createStartupAttempt } from "./voiceStartup";
export { createStartupAttempt, MICROPHONE_TIMEOUT_MS, CONNECTION_TIMEOUT_MS } from "./voiceStartup";

export function useOralVoiceStartup() {
  const [stage, setStage] = useState("idle");
  const [error, setError] = useState(null);
  const attemptRef = useRef(null);
  const retryRef = useRef(null);
  const busyRef = useRef(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      attemptRef.current?.cancel();
      retryRef.current = null;
    };
  }, []);

  const start = async (connect, cleanup) => {
    if (busyRef.current || !mountedRef.current) return;
    busyRef.current = true;
    setError(null);
    const attempt = createStartupAttempt(setStage);
    attemptRef.current = attempt;
    retryRef.current = () => start(connect, cleanup);
    try {
      await connect(attempt);
      if (attempt.active && mountedRef.current) {
        setStage("ready");
        retryRef.current = null;
      }
    } catch (failure) {
      attempt.cancel();
      if (!mountedRef.current || failure.code === "startup_cancelled") return;
      if (cleanup(failure.cause || failure) === false) {
        retryRef.current = null;
        setStage("idle");
        return;
      }
      const detail = { code: failure.code || failure.name || "voice_startup_error", stage: failure.stage || "connecting_voice" };
      console.error("Oral voice startup failed", detail);
      setError(detail);
      setStage("failed");
    } finally {
      busyRef.current = false;
    }
  };
  const reset = () => {
    attemptRef.current?.cancel();
    retryRef.current = null;
    setError(null);
    setStage("idle");
  };
  return { start, reset, stage, error, retry: () => retryRef.current?.(), busy: !["idle", "ready", "failed"].includes(stage) };
}
